<template>
  <div
    v-if="userInfo"
    class="close-statement"
    :class="{
      'close-statement--android': $isAndroid,
    }"
  >
    <div class="close-statement__title">
      Дербес деректерді жинауға және өңдеуге келісім
    </div>
    <div class="close-statement__main">
      <div class="close-statement__main_block">
        Мен, {{ userInfo.fio }},<br />ЖСН {{ userInfo.iin }},  «Kaspi Bank» АҚ-қа (БСН 971240001315) (бұдан әрі – Kaspi):
        <ol>
        <li>
          Kaspi-дің мен көрсеткен дербес деректерімді және кәмелетке толмаған
          балаларымның/қамқорымдағылардың дербес деректерін (бұдан әрі – Деректер) жинауына,
          өңдеуіне, соның ішінде оларды трансшекаралық беруіне, мені және менің құжаттарымды суретке
          түсіруіне;
        </li>
        <li>
          Деректерімді және мен туралы мәліметтерді төменде аталған мақсатта Kaspi-ден үшінші
          тұлғаларға, зейнетақы төлеу жөніндегі уәкілетті ұйымға, мемлекеттік органдардың,
          ұйымдардың деректер базасына және тұлғаларға тікелей және үшінші тұлғалар арқылы беруіне,
          сондай-ақ мен туралы мұндай ақпаратты, соның ішінде Деректерім қамтылған ақпаратты аталған
          тұлғалардан алуына;
        </li>
        <li>
          Kaspi-дің Деректерімді:<br />
          <ul>
            <li>
              Kaspi мобильді қосымшасындағы сервистерді пайдаланып, кез келген мәмілені жасасу және
              орындау, соның ішінде тауарларды, жұмыстар мен қызметтерді сатып алу;
            </li>
            <li>
              мемлекеттік қызметтерді және «Азаматтарға арналған үкімет» мемлекеттік корпорациясы»
              КЕАҚ және басқаларын қосқанда, мемлекеттік органдармен және ұйымдармен өзара әрекет
              еткен кезде Қазақстан Республикасының заңнамасында көзделген құқықтарым мен
              міндеттерімді іске асыруға байланысты өзге қызметтерді алу;
            </li>
            <li>
              «Kaspi Bank» АҚ Куәландырушы орталығының электрондық цифрлық қолтаңбасын шығару;
            </li>
            <li>Kaspi мен оның серіктестерінің қызметтері туралы мәліметтерді беру;</li>
            <li>елден тысқары жерде транзакциялар жасау немесе деректерді бұлтты өңдеу;</li>
            <li>
              Kaspi-дің алдында туындаған кез келген берешегімді өндіріп алу үшін Деректерімді
              жалпыға бірдей қолжетімді дереккөздерде тарату мақсатында (бұдан әрі – Мақсаттар)
              пайдалануына келісімімді беремін;
            </li>
            <li>
              алаяқтық, шоттан ақша ұрлау, өзге де құқыққа қайшы әрекеттер жағдайларын анықтау,
              мұндай құқыққа қайшы әрекеттердің алдын алу немесе осындай әрекеттердің салдарын
              оқшаулау;
            </li>
            <li>
              заңсыз жолмен алынған кірістерді жылыстатуға, терроризмді, экстремизмді, жаппай
              қырып-жою қаруын әзірлеуді қаржыландыруға қарсы іс-қимыл бойынша іс-шараларды орындау
              мақсатында (бұдан әрі – Мақсаттар) пайдалануына келісімімді беремін.
            </li>
          </ul>
        </li>
      </ol>
      </div>

      <div class="close-statement__main_block">
        Осы арқылы белгіленген Мақсаттарға жету үшін қажетті және жеткілікті Деректердің тізбесін өз
        бетінше айқындау құқығын Kaspi-ге бергенімді растаймын.
      </div>


    </div>
    <div class="close-statement__divider"></div>
    <CommonButton class="close-statement__btn" @click="goToScoring">
      Келісемін, ары қарай
    </CommonButton>
  </div>
</template>

<script>
import CommonButton from "@/components/shared/button/CommonButton";
import { saveConsent } from "@/api/consent";

export default {
  components: {
    CommonButton,
  },
  props: {
    userInfo: {
      type: [Object, null],
      required: true,
    },
  },
  methods: {
    async goToScoring() {
      await saveConsent(true);
      this.$router.replace("/bank/red/limits");
    },
  }
};
</script>
